import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { LucideAngularModule } from 'lucide-angular';

export interface Webinar {
  titleKey: string;
  descriptionKey: string;
  duration: string;
  registrationUrls: Record<string, string>;
}

@Component({
  selector: 'app-webinar-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    ButtonModule,
    LucideAngularModule,
  ],
  templateUrl: './webinar-card.component.html'
})
export class WebinarCardComponent {
  webinar = input.required<Webinar>();

  get registrationLanguages(): { lang: string; url: string }[] {
    const urls = this.webinar().registrationUrls;
    return Object.entries(urls).map(([lang, url]) => ({ lang, url }));
  }
}
